// extracted by mini-css-extract-plugin
module.exports = {"incCard":"IncCard_incCard__3V6OG","title":"IncCard_title__3cH_Z","list":"IncCard_list__kmj_5"};